import React from "react";

const More = () => {
  return <div className="primary">More</div>;
};

export default More;
